exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-42db8f42] .vs__dropdown-toggle {\n  padding-bottom: 2.5px !important;\n}\n", ""]);

// exports
